export default __webpack_public_path__ + "static/assets/d728f305eb7336613732ca1f3ac68ba9.png";